import './bootstrap';

import * as commonScripts from './common/util';
import {componentScripts} from './index';

// append 'is-ie' class for CSS leverage
if (commonScripts.default.detectIE()) {
    document.body.classList.add('is-ie');
}

// after document loads, loop over all [data-component]s on the page
document.addEventListener('DOMContentLoaded', () =>
{
	// find all elements with component attribute
    const componentElements = document.querySelectorAll('[data-component]');

    // iterate over all component elements
    for (const el of componentElements) {
        let componentName = el.getAttribute('data-component');

        // get the script that matches the component
        let componentScript = componentScripts[componentName];

        // if the script exists, fire the init
        if (typeof componentScript != 'undefined') {
            componentScript.init(el);
        }

        // apply component animations if defined
        // if (el.getAttribute('data-animate') === 'true') {
        //     commonScripts.util.componentAnimation(el);
        // }
    }
});
import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();
